import { Difficulty } from "../../../Difficulty";

export const faderGraderOptions: {
  [difficulty in Difficulty]: {
    options: number[];
    steps: number;
    min: number;
    max: number;
  };
} = {
  easy: {
    steps: 7,
    min: -21,
    max: 0,
    options: [0, -7, -14, -21],
  },
  medium: {
    steps: 4,
    min: -20,
    max: 0,
    options: [0, -4, -8, -12, -16, -20],
  },
  hard: {
    steps: 2,
    min: -20,
    max: 0,
    options: [0, -2, -4, -6, -8, -10, -12, -14, -16, -18, -20],
  },
};
